import type { PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'

export { RouterProvider }

const RouterProvider = ({ children }: PropsWithChildren) => {
  return <BrowserRouter>{children}</BrowserRouter>
}
